/**
 * Contact form subject options
 * Used in ContactForm.vue for both template rendering and validation schema
 */
export const CONTACT_SUBJECTS = [
  { value: 'derecho-olvido', label: 'Derecho al Olvido' },
  { value: 'derecho-olvido-postmortem', label: 'Derecho al Olvido Post-Mortem' },
  { value: 'testamento-digital', label: 'Testamento Digital' },
  { value: 'precios', label: 'Consulta sobre precios' },
  { value: 'soporte', label: 'Soporte t\u00e9cnico' },
  { value: 'otro', label: 'Otro' }
]

export const CONTACT_SUBJECT_VALUES = CONTACT_SUBJECTS.map(s => s.value)
